import RangeField from '@cnamts/vue-dot/src/patterns/RangeField'

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(RangeField,_vm._b({attrs:{"min":_vm.field.min,"max":_vm.field.max,"value":_vm.field.value},on:{"change":_vm.emitChangeEvent}},'RangeField',_vm.field.fieldOptions,false))
}
var staticRenderFns = []

export { render, staticRenderFns }